export default "__VITE_ASSET__a7d91af0__"